import React from 'react';

const DemoCareerConstellationCard = ({ careerMatrix }) => {
    return (
        <div className="rounded-[2rem] border border-white/60 bg-white/80 backdrop-blur-xl p-6 md:p-8 shadow-[0_12px_40px_rgba(0,0,0,0.05)]">
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-3 mb-6">
                <h2 className="text-2xl md:text-3xl font-black text-[#171717] brand-font">{careerMatrix.title}</h2>
                <p className="text-sm md:text-base text-gray-500 font-semibold">Decision Making</p>
            </div>

            <div className="overflow-x-auto">
                <div className="min-w-[820px]">
                    <div className="grid grid-cols-[180px_repeat(3,minmax(0,1fr))] gap-3 mb-3">
                        <div></div>
                        {careerMatrix.columns.map((column) => (
                            <div key={column} className="rounded-2xl bg-gradient-to-r from-[#fff4eb] to-[#f7efff] px-4 py-3 text-center font-bold text-[#171717] brand-text">
                                {column}
                            </div>
                        ))}
                    </div>

                    <div className="grid gap-3">
                        {careerMatrix.rows.map((row) => (
                            <div key={row.title} className="grid grid-cols-[180px_repeat(3,minmax(0,1fr))] gap-3 items-stretch">
                                <div className="rounded-2xl bg-[#faf7f4] px-4 py-5 flex items-center justify-center text-center font-bold text-[#171717] brand-text border border-[#f1e7de]">
                                    {row.title}
                                </div>
                                {row.cells.map((cell, index) => (
                                    <div
                                        key={`${row.title}-${index}`}
                                        className="rounded-2xl px-4 py-5 border leading-relaxed text-sm md:text-base brand-text shadow-sm"
                                        style={{
                                            background: index === 0 ? '#fff7f0' : index === 1 ? '#eefaf5' : '#f8f1ff',
                                            borderColor: index === 0 ? '#fed7aa' : index === 1 ? '#bbf7d0' : '#e9d5ff'
                                        }}
                                    >
                                        {cell}
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DemoCareerConstellationCard;
